(function (module) {
    "use strict";
    module.service("clipboardService", [clipboardService]);
    function clipboardService() {

        function getData(clipboard: $TSFixMe) {
            const pastedData = clipboard.getData('text/plain');
            return parseData(pastedData);
        }

        function parseData(data: $TSFixMe) {
            return data.replace(/(?:\n)/g, '\t').trim().split(/\t+/).map((c: $TSFixMe) => c.replace(/\s+/g, '').replace(/,/g, '.'))
                .filter((p: $TSFixMe) => p && !/[a-zA-Z]/.test(p) && !isNaN(parseFloat(p))).map((p: $TSFixMe) => parseFloat(p));
        }

        return {
            getData: getData
        };
    }

})(angular.module('topline.services'));